module.exports = __webpack_public_path__ + "static/title-fb6797478905618729361a54b3465410.svg";